class CollectionFilters {
  constructor() {
    this.filterSelects = document.querySelectorAll('.filter-select');
    this.sortSelect = document.querySelector('.sort-select');
    this.init();
  }

  init() {
    // Inicializar los valores de los filtros desde la URL
    this.setFiltersFromUrl();

    // Event listeners para los filtros
    this.filterSelects.forEach((select) => {
      select.addEventListener('change', () => this.handleFilterChange());
    });

    // Event listener para el ordenamiento
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => this.handleSortChange());
    }
  }

  setFiltersFromUrl() {
    const searchParams = new URLSearchParams(window.location.search);

    // Establecer valores iniciales de los filtros
    this.filterSelects.forEach((select) => {
      const paramValue = searchParams.get(select.name);
      if (paramValue) {
        select.value = paramValue;
      }
    });

    // Establecer valor inicial del ordenamiento
    if (this.sortSelect) {
      const sortValue = searchParams.get('sort_by');
      if (sortValue) {
        this.sortSelect.value = sortValue;
      }
    }
  }

  handleFilterChange() {
    const searchParams = new URLSearchParams(window.location.search);

    // Actualizar parámetros de filtro
    this.filterSelects.forEach((select) => {
      if (select.value) {
        searchParams.set(select.name, select.value);
      } else {
        searchParams.delete(select.name);
      }
    });

    // Mantener el parámetro de ordenamiento si existe
    if (this.sortSelect && this.sortSelect.value) {
      searchParams.set('sort_by', this.sortSelect.value);
    }

    this.updateUrl(searchParams);
  }

  handleSortChange() {
    const searchParams = new URLSearchParams(window.location.search);

    if (this.sortSelect.value) {
      searchParams.set('sort_by', this.sortSelect.value);
    } else {
      searchParams.delete('sort_by');
    }

    this.updateUrl(searchParams);
  }

  updateUrl(searchParams) {
    const newUrl = `${window.location.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
    window.location.href = newUrl;
  }
}

// Inicializar los filtros cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});
